module.exports = __webpack_public_path__ + "static/img/1_10_2.61429040.jpg";